<template>
    <div class="form-container">
      <!-- 标题部分 -->
      <div class="form-header">
        <h1 class="form-title">购买Telegram会员</h1>
        <p class="form-subtitle">使用你的加密钱包购买Telegram会员，为自己或你的朋友开通。</p>
      </div>
  
      <!-- 用户名输入 -->
      <a-form layout="vertical" class="purchase-form">
        <a-form-item label="输入要开通的Telegram用户名" class="form-item">
          <p style="margin-top: 24px;">输入要开通的Telegram用户名</p>
          <a-input
            v-model:value="username"
            placeholder="输入Telegram用户名，例如：@username"
            size="large"
            style="background-color: black;"
          >
            <template #prefix>
              <user-outlined />
            </template>
          </a-input>
        </a-form-item>
  
        <!-- 开通时长选择 -->
        <a-form-item label="选择开通时长" class="form-item">
            <div style="display: flex; align-items: center; margin-bottom: 10px;margin-top: 16px;">
                <p style="margin: 0 8px 12px 0;">选择开通时长</p>
                <div class="duration-badge">最佳优惠</div>
            </div>
            
          <a-radio-group v-model:value="selectedDuration" class="duration-options">
            
            <a-radio-button
              v-for="option in durationOptions"
              :key="option.value"
              :value="option.value"
              class="duration-option"
            >
              <div class="option-content">
                <div class="option-title">
                  {{ option.label }}
                  <span class="discount-badge">{{ option.discount }}</span>
                </div>
                <div class="option-price">
                  <span class="price">{{ option.price }}</span>
                  <span class="usd-price">~ {{ option.usdPrice }}</span>
                </div>
              </div>
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
  
        <!-- 购买按钮 -->
        <a-button
          type="primary"
          size="large"
          block
          class="purchase-btn"
          @click="handlePurchase"
        >
          立即购买
        </a-button>
      </a-form>
    </div>
  </template>
  
  <script>
import { readReferralFromSearch } from '../util/deeplink';
import { serializePaymentPayload } from '../util/paymentFlow';
  import { UserOutlined } from '@ant-design/icons-vue';
  import { message } from 'ant-design-vue';
  import { addOrder } from '../util/api'; 
  
  export default {
    name: 'MemberForm',
    components: {
      UserOutlined
      
    },

    data() {
      return {
       
        referral_code:"",
        gameGroupId:"",
        username: '',
        selectedDuration: '3months',
        durationOptions: [
          {
            value: '3months',
            label: '3个月',
            discount: '-20%',
            price: '10.00',
            usdPrice: '$10.00'
          },
          {
            value: '6months',
            label: '6个月',
            discount: '-47%',
            price: '16.00',
            usdPrice: '$16.00'
          },
          {
            value: '12months',
            label: '12个月',
            discount: '-52%',
            price: '30.00',
            usdPrice: '$30.00'
          }
        ]
      };
    },


    methods: {
      async handlePurchase()  {
        const { referralCode, gameGroupId: gidFromUrl } = readReferralFromSearch(window.location.search);
      this.referral_code = referralCode;
      this.gameGroupId = gidFromUrl;

        console.log(this.referral_code)
        if (!this.username) {
          message.warning('请输入Telegram用户名');
          return;
        }
  
        const selectedOption = this.durationOptions.find(
          option => option.value === this.selectedDuration
        );

          
        let str = this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        let data = {
            price:selectedOption.price,
            inputNumber:1,
            inputGT:this.username,
            orderNo: str,
            title:selectedOption.label+"会员",
            referral_code:this.referral_code
        }
  
        message.success(
          `即将为 ${this.username} 开通 ${selectedOption.label} 会员，金额: ${selectedOption.usdPrice}`
        );

        await addOrder(data)

        this.$router.push({ name: 'Payment', params: { data: serializePaymentPayload(data, this.gameGroupId) } });

      }
      ,
       getCurrentDateTime ()   {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }
    }
  };
  </script>
  
  <style scoped lang="less">
  .form-container {
    padding: 16px;
    color: #fff; /* 确保子组件文字也是白色 */
  
    .form-header {
      text-align: center;
      margin-bottom: 24px;
  
      .form-title {
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 8px;
      }
  
      .form-subtitle {
        font-size: 14px;
        color: #fff;
      }
    }
  
    .form-item {
      margin-bottom: 24px;
  
      :deep(.ant-form-item-label) {
        font-weight: 500;
        padding-bottom: 8px;
      }
    }
  
    .duration-badge {
      //display:flex;
      background: #f6ffed;
      border: 1px solid #b7eb8f;
      height: 22px;
      color: #52c41a;
      float: left;
      padding: 0 8px;
      border-radius: 4px;
      font-size: 12px;
      margin-bottom: 12px;
    }
  
    .duration-options {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;
      border-radius: 12px;
  
      .duration-option {
        height: auto;
        padding: 12px 16px;
        text-align: left;
        line-height: 1.5;
        background: #000;
        border-radius: 12px;
  
        .option-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
  
          .option-title {
            font-weight: 500;
            
            .discount-badge {
              background: #fff2e8;
              color: #fa8c16;
              padding: 2px 6px;
              border-radius: 10px;
              font-size: 12px;
              margin-left: 8px;
            }
          }
  
          .option-price {
            text-align: right;
            
            .price {
              font-weight: 600;
              color: #1890ff;
            }
            
            .usd-price {
              color: rgba(0, 0, 0, 0.45);
              font-size: 12px;
              margin-left: 4px;
            }
          }
        }
      }
    }
  
    .purchase-btn {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
      margin-top: 24px;
    }
  }

  :deep(.duration-options) {
  .ant-radio-button-wrapper {
    /* 基础样式 */
    border: 1px solid transparent !important;
    background: rgba(255, 255, 255, 0.1) !important;
    transition: all 0.3s;
    
    /* 选中状态 */
    &.ant-radio-button-wrapper-checked {
      background: #1890ff !important;
      box-shadow: none !important;
    }
    
    /* 移除相邻边框 */
    &::before {
      display: none !important;
    }
  }
}
  </style>